<template>
  <a-modal
    :visible="visible"
    title="서명 입력"
    @cancel="handleCancel"
    :footer="null"
    width="650px"
  >
    <div class="signature-modal-content">
      <p>아래 영역에 {{ isMobile ? '손가락' : '마우스' }}으로 서명해주세요.</p>
      
      <SignatureCanvas 
        ref="signatureCanvas"
        :width="600" 
        :height="250"
        :lineWidth="3"
      />
      
      <div class="signature-modal-actions">
        <a-button @click="handleCancel">취소</a-button>
        <a-button @click="handleClear" style="margin-left: 8px;">다시 그리기</a-button>
        <a-button type="primary" @click="handleSave" style="margin-left: 8px;">저장</a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import SignatureCanvas from './SignatureCanvas.vue';

export default {
  name: 'SignatureModal',
  components: {
    SignatureCanvas
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    initialSignature: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isMobile: false
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (this.initialSignature) {
            this.loadInitialSignature();
          } else {
            this.handleClear();
          }
        });
      }
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDevice);
  },
  methods: {
    checkDevice() {
      // 간단한 모바일 기기 감지
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleClear() {
      this.$refs.signatureCanvas.clearCanvas();
    },
    handleSave() {
      const signatureData = this.$refs.signatureCanvas.canvas.toDataURL('image/png');
      this.$emit('save', signatureData);
    },
    loadInitialSignature() {
      if (!this.initialSignature || !this.$refs.signatureCanvas) return;
      
      const img = new Image();
      img.onload = () => {
        const canvas = this.$refs.signatureCanvas.canvas;
        const ctx = canvas.getContext('2d');
        
        // 캔버스 초기화
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        // 이미지 그리기
        ctx.drawImage(img, 0, 0);
      };
      img.src = this.initialSignature;
    }
  }
};
</script>

<style scoped>
.signature-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.signature-modal-actions {
  margin-top: 16px;
  text-align: right;
  width: 100%;
}
</style> 